;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('JobOutcomePolicyService', [
      'JobOutcomePolicyFactory',
      'ServiceUtils',
      JobOutcomePolicyService
    ])

  function JobOutcomePolicyService(JobOutcomePolicyFactory, ServiceUtils) {
    return {
      getJobOutcomePolicy: getJobOutcomePolicy,
      getJobOutcomePolicyByApplications: getJobOutcomePolicyByApplications,
      deleteJobOutcomePolicy: deleteJobOutcomePolicy
    }

    function getJobOutcomePolicy() {
      return JobOutcomePolicyFactory.getJobOutcomePolicy()
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getJobOutcomePolicyByApplications(applications) {
      return JobOutcomePolicyFactory.getJobOutcomePolicyByApplications(
        applications
      )
        .then(ServiceUtils.handleResolve('data.job_outcome_policy'))
        .catch(ServiceUtils.handleError)
    }

    function deleteJobOutcomePolicy(id) {
      return JobOutcomePolicyFactory.deleteJobOutcomePolicy(id)
    }
  }
})()
